function Signal() {
    let SIGNALR_URL = process.env.REACT_APP_CC_BASE_URL_SINGNALR;

    return SIGNALR_URL;
}

export default Signal;
